import makeStyles from '@mui/styles/makeStyles';

const useCurrencySelectStyles = makeStyles({
  root: {}
});

export default useCurrencySelectStyles;
